module.exports = __webpack_public_path__ + "static/media/_MIC2410.image.498ff526.png";